import React from 'react';
import './MuultiStyle.css';
import { Link } from 'react-router-dom';
export default function Footer() {
    return (
        <footer className="muulti-footer">
            <div className="muulti-footer__content">

                <div className="muulti-footer__col">
                    <h4>About Muulti</h4>
                    <p>Build your space.</p>
                </div>
                <div className="muulti-footer__col">
                    <h4>Resources</h4>
                    <ul>
                        <li><a href="/muulti-directory">Muulti Directory</a></li>
                        <li><p>Produced by: </p><a href="https://thesimulacrum.xyz" target="_blank" rel="noopener noreferrer">The Simulacrum</a></li>
                        <li><p>Developed by: </p><a href="https://www.kylehintonprojects.com/" target="_blank" rel="noopener noreferrer">Simulations</a></li>
                        <li><Link to="/legal/license" target="_blank" rel="noopener noreferrer">License</Link></li>
                        <li><Link to="/legal/copyright" target="_blank" rel="noopener noreferrer">Copyright</Link></li>
                        <li><Link to="/legal/privacy" target="_blank" rel="noopener noreferrer">Privacy</Link></li>
                    </ul>
                </div>
                <div className="muulti-footer__col">
                    <h4>Follow Us</h4>
                    <ul>
                        <li><a href="https://x.com/muulti_space" target="_blank" rel="noopener noreferrer">Twitter</a></li>
                    </ul>
                </div>
            </div>



            <div className="muulti-footer__bottom">
                <small>© {new Date().getFullYear()} Muulti — All rights reserved.</small>
            </div>
            <div>
                <p style={{ color: 'white' }}>
                    v0.17.25
                </p>
            </div>
        </footer>
    );
}
